/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/* eslint-disable no-duplicate-imports */
//import * as MsDyn365 from '@msdyn365-commerce/core';
//import classnames from 'classnames';
import * as React from 'react';
import { ICustomContentcodeBlockProps } from './custom-contentcode-block.props.autogenerated';

export interface ITextBlockViewProps extends ICustomContentcodeBlockProps<{}> {
    paragraph?: React.ReactNode;
    className?: string;
}

/**
 *
 * TextBlock component
 */
class TextBlock extends React.PureComponent<ICustomContentcodeBlockProps<{}>> {
    public render(): JSX.Element | null {
        const paragraph = this.props.config.paragraph || '';

        // tslint:disable:react-no-dangerous-html -- intentionally set inner html
        return <div suppressHydrationWarning dangerouslySetInnerHTML={{ __html: paragraph }} />;
    }
}
export default TextBlock;
